import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Sparkles, ArrowRight } from 'lucide-react';

/**
 * Sticky "Start free" CTA that slides in from the top-right once the user has
 * scrolled past the hero (default 600px). Sits just below the nav so it never
 * collides with logo/links. Includes a subtle pulse-ping to draw the eye but
 * fades out on hover so it doesn't feel pushy.
 */
const StickyCta = ({ threshold = 600 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return (
    <Link
      to="/signup"
      data-testid="landing-sticky-cta"
      aria-hidden={!show}
      tabIndex={show ? 0 : -1}
      className={`fixed top-20 right-4 sm:right-6 z-40 transition-all duration-500 ease-out ${
        show
          ? 'opacity-100 translate-y-0 pointer-events-auto'
          : 'opacity-0 -translate-y-2 pointer-events-none'
      }`}
    >
      <Button
        size="sm"
        className="relative bg-gradient-to-r from-teal-400 to-emerald-500 text-slate-900 hover:opacity-90 font-semibold shadow-lg shadow-emerald-500/30 group h-9 pr-3"
      >
        {/* Pulse-ping indicator */}
        <span
          className="absolute -top-1 -right-1 flex h-2.5 w-2.5"
          aria-hidden
        >
          <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-300" />
        </span>
        <Sparkles className="w-3.5 h-3.5 mr-1" />
        Start free
        <ArrowRight className="w-3.5 h-3.5 ml-1 transition-transform group-hover:translate-x-0.5" />
      </Button>
    </Link>
  );
};

export default StickyCta;
